// extracted by mini-css-extract-plugin
export default {"innerWrapper":"hero-text-block-module--innerWrapper--f93a8","wrapper":"hero-text-block-module--wrapper--7e108"};